import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevron-right.svg'
import _imports_1 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-1761670d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "staging-bar-title" }, " You're in a testing environment. ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-user-menu-icon",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-user-menu-icon",
  src: _imports_1
}, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutStagingBar',
  setup(__props) {

const isSmall = ref(false)

onMounted(async () => {
  isSmall.value = !!localStorage.getItem('stagingBarSmall')
})

const toggle = () => {
  isSmall.value = !isSmall.value
  localStorage.setItem('stagingBarSmall', 'true')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["staging-bar", { 'staging-bar--small': isSmall.value }])
  }, [
    _hoisted_1,
    (isSmall.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "staging-bar-action",
          onClick: toggle
        }, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "staging-bar-action",
          "data-plankton-test": "bar-close",
          onClick: toggle
        }, _hoisted_5))
  ], 2 /* CLASS */))
}
}

})